import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import Button from '../../elements/Button';
import Text from '../../fields/Text';
import IconSearch from '../../icons/IconSearch';
import IconWarning from '../../icons/IconWarning';
import styles from './styles.scoped.css';
import LoadingBars from '../../elements/LoadingBars';

export default function CustomerSearchForm({
  handleSubmit, message, isError, isLoading
}) {
  const dispatch = useDispatch();
  const { values } = useSelector((state) => state.form.customerSearchForm);
  const onSubmit = async (e) => {
    e.preventDefault();
    handleSubmit(values);
  };

  useEffect(() => {
    if(!/^[0-9]*$/.test(values.nationalityId)){
      const nationalityId = values.nationalityId.replace(/[^0-9]/g, '');
      dispatch(change('customerSearchForm', 'nationalityId', nationalityId));
    }
  }, [values.nationalityId]);

  return(
    <form className={styles.formContainer} onSubmit={onSubmit}>
      <Field
        component={Text}
        inputProps={{
          placeholder: 'Masukkan NIK..',
          maxLength: 16,
        }}
        meta={{
          error: (isError) && <>
            <IconWarning className={styles.icon} color="#CF212A" /> {message}
          </>,
          touched: true,
        }}
        name={'nationalityId'}
      />
      <div className={styles.containerBtn}>
        <Button
          className={styles.btn}
          disabled={!values.nationalityId || values.nationalityId.length < 16 || isLoading}
          style={'blue'}
          type={'submit'}
        >{isLoading ? <LoadingBars size={1}/> : <IconSearch />}
        Cari Pelanggan
        </Button>
      </div>
    </form>
  );
}

CustomerSearchForm.propTypes = {
  handleSubmit: PropTypes.func,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};
